<template>
 
  <div>
    <label  for="season"><strong>REPARTO</strong>    
    </label>
   <!--
    <a href="#" @click="reset()" class="btn btn-light btn-sm ml-3">
      <i style="color:brown" class="fas fa-sync" aria-hidden="true"></i>
    </a>  
  -->
    <div class="input-group_">  
    <v-select
    
    :searchable="true" multiple  :clearable="false" :loading="loading"  @input="setData"  :options="options" v-model="selected" :reduce="department => department.departmentId" label="department">
    
    <template #search="{attributes, events}">
    <input
      class     = "vs__search"
      :required = props.required
      :disabled = !props.isActive
      v-bind    = "attributes"
      v-on      = "events"
      
    />
    </template>

      
      <template #selected-option="{department}">
  
      <div style="display: flex; align-items: baseline">
        <strong>{{ department }}</strong>          
      </div>

    </template>
  
 
    </v-select>

   
    </div>

    
  </div>
</template>


<script>


import api     from "@/api"
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {mapGetters }   from 'vuex'


export default {
props: ['props'],
components: { vSelect },
data() {
    return {

        
        selected : null,
        options  : [],
        loading  : false,

        

    
        
    };
  },
computed: {
  ...mapGetters(['company']) 
  },
mounted: function () {
  
  this.getData()
  
},
  
methods: {

  reset()
  {
    this.selected = []
    this.$emit("update", []);
 
  },
  setData(departmentId)
  {
   

    const arr = departmentId.toString().split(',')
    
    
    let text = ''
    arr.forEach(item => {
    
      
      this.options.forEach(option =>{
        if(option.departmentId == item)
        {
          text +=  option.department + '-'
          
        }
        
      })
      

    })
    
    
    
    if(departmentId.length == 0)
    {
      this.selected = null
    }
    this.$emit("update", departmentId,text);
  },
  async getData()
    {            
      
      this.loading = true  
      let sp       = {'sp'        : 'spDepartmentSelect'}
      //let data     = {'companyId' : this.company.Id}
      //let json     = Object.assign(data, sp);  

      await api.post(sp).then(res => {
            if(res.status==200)
            {
                
                const options = res.data.recordsets[0]

                this.options  = options
                if(this.props.selection.length > 0)
                {
                  this.selected = this.props.selection
                } 
                
                

                      
            }
           else if(res.status==500)
           {
                console.log(res.data)

            } 
          else
            {
                console.log('Network Error.')                  
                 
            } 
      
      

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
            this.loading = false
        });

    

    },
  

}
}
</script>

<style scoped >
h4 {
  font-family: 'Roboto Condensed';
  /*font-size: 16px;*/
}

</style>
